module.exports = __webpack_public_path__ + "img/logo.32322d3c.png";